import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  viewAllLink?: string;
  viewAllText?: string;
  className?: string;
  id?: string;
}

/**
 * SectionHeader - Standardized section title component
 * 
 * Uses design tokens for consistent typography across all pages.
 * Mobile: text-lg, Desktop: text-2xl/3xl
 */
export function SectionHeader({ 
  title, 
  viewAllLink, 
  viewAllText = 'View All',
  className,
  id
}: SectionHeaderProps) {
  return (
    <div className={cn(
      "flex items-center justify-between",
      "mb-[var(--space-4)] md:mb-[var(--space-6)]",
      className
    )}>
      <h2 
        id={id} 
        className={cn(
          "font-display font-bold text-headline",
          // Token-based responsive sizing
          "text-[length:var(--text-lg)] sm:text-[length:var(--text-xl)]",
          "md:text-[length:var(--text-2xl)] lg:text-[length:var(--text-3xl)]"
        )}
      >
        {title}
      </h2>
      {viewAllLink && (
        <Link 
          to={viewAllLink}
          className={cn(
            "flex items-center gap-1 font-medium",
            "text-[length:var(--text-sm)] text-primary",
            "hover:text-primary/80 transition-colors"
          )}
        >
          <span className="hidden sm:inline">{viewAllText}</span>
          <span className="sm:hidden">All</span>
          <ArrowRight className="h-3 w-3 md:h-4 md:w-4" />
        </Link>
      )}
    </div>
  );
}